import { Variation } from '@/@core/services/app.service'
import { TableColumnsType } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Stack,
  Typography,
  Box,
  Chip,
  IconButton,
  Badge,
  Slide
} from '@mui/material'

import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip'
import { useContext } from 'react'
import { AbilityContext } from '@/layouts/components/acl/Can'
import { styled } from '@mui/material/styles'
import CommentOutline from 'mdi-material-ui/CommentOutline'
import { ExternalLinks } from '@/@core/services/api'
import { Circle, CircleHalfFull, MenuDown } from 'mdi-material-ui'
import {
  addCommas,
  chromosomeRegion,
  formatVariantInheritance,
  isJson,
  isWindow,
  renameChildTypes,
  unique,
  switchACMG
} from '@/@core/utils/utils'
import { useRouter } from 'next/router'
import { Rating } from '@mui/material'

interface Props {
  setCurrent: any
  setOpen: any
  setHistoryOpen: any
  setCommentsOpen: any
  setTranscript_list: any
  handleMenuClick: any
  getColumnSearchProps: any
  setFilterGeneOpen: any
  setMenuType: any
  setFilterGeneData: any
  getFilterGene: any
  setIndexOpen: any
  setGeneIndexOpen: any
  setGeneOpen: any
  setAcmgOpen: any
  setOMIMOpen: any
  setIgvOpen: any
  setIgvLocus: any
  setCnvScipOpen: any
  setCnvAllOpen: any
  VariationGeneRef: any
  analysisInfo: any
  query: any
}
const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  // [`& .${tooltipClasses.tooltip}`]: {
  //   backgroundColor: 'rgba(97, 97, 97)',
  //   color: 'rgb(255, 255, 255)',
  //   maxWidth: 220,
  //   fontSize: theme.typography.pxToRem(12),
  //   border: '1px solid #dadde9'
  // }
}))

const TypographyA = styled(Typography)(() => ({
  fontSize: '0.8rem',
  color: 'inherit'
}))

const Badges = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: '-10px',
    backgroundColor: 'rgb(110,200,229)'
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}))

const CustomWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 500,
    maxHeight: 400,
    overflow: 'auto'
  }
})
const chromosome = [
  {
    text: 'chr1',
    value: '1'
  },
  {
    text: 'chr2',
    value: '2'
  },
  {
    text: 'chr3',
    value: '3'
  },
  {
    text: 'chr4',
    value: '4'
  },
  {
    text: 'chr5',
    value: '5'
  },
  {
    text: 'chr6',
    value: '6'
  },
  {
    text: 'chr7',
    value: '7'
  },
  {
    text: 'chr8',
    value: '8'
  },
  {
    text: 'chr9',
    value: '9'
  },
  {
    text: 'chr10',
    value: '10'
  },
  {
    text: 'chr11',
    value: '11'
  },
  {
    text: 'chr12',
    value: '12'
  },
  {
    text: 'chr13',
    value: '13'
  },
  {
    text: 'chr14',
    value: '14'
  },
  {
    text: 'chr15',
    value: '15'
  },
  {
    text: 'chr16',
    value: '16'
  },
  {
    text: 'chr17',
    value: '17'
  },
  {
    text: 'chr18',
    value: '18'
  },
  {
    text: 'chr19',
    value: '19'
  },
  {
    text: 'chr20',
    value: '20'
  },
  {
    text: 'chr21',
    value: '21'
  },
  {
    text: 'chr22',
    value: '22'
  },
  {
    text: 'chrX',
    value: 'X'
  },
  {
    text: 'chrY',
    value: 'Y'
  },
  {
    text: 'chrMT',
    value: 'MT'
  }
]

const color = [
  {
    key: 'pathogenic',
    value: 'pathogenic',
    color: 'rgba(229,38,35,0.8)'
  },
  {
    key: 'likely pathogenic',
    value: 'likely pathogenic',
    color: 'rgba(221,109,32,0.8)'
  },
  {
    key: 'drug response',
    value: 'drug response',
    color: 'rgb(46, 125, 50,0.8)'
  },
  {
    key: 'uncertain significance',
    value: 'uncertain significance',
    color: 'rgb(240,239,240,0.4)'
  },
  {
    key: 'likely benign',
    value: 'likely benign',
    color: 'rgb(107,148,200,0.8)'
  },
  {
    key: 'benign',
    value: 'benign',
    color: 'rgb(109,56,149,0.8)'
  },
  {
    key: 'loss of function',
    value: 'loss of function',
    color: 'rgb(237, 108, 2,0.8)'
  }
]

const GLScolor = [
  {
    key: 'pathogenic',
    value: 'pathogenic',
    color: 'rgb(218,150,148)'
  },
  {
    key: 'likely pathogenic',
    value: 'likely benign',
    color: 'rgb(245,182,193)'
  },
  {
    key: 'drug response',
    value: 'drug response',
    color: 'rgb(186,204,147)'
  },
  {
    key: 'uncertain significance',
    value: 'uncertain significance',
    color: 'rgb(240,239,240)'
  },
  {
    key: 'likely benign',
    value: 'likely benign',
    color: 'rgb(107,148,200)'
  },
  {
    key: 'benign',
    value: 'benign',
    color: 'rgb(64,113,190)'
  },
  {
    key: 'loss of function',
    value: 'loss of function',
    color: 'rgb(246,209,139)'
  }
]

export const judgeType = (str: string, arr: any[]) => {
  if (str.includes('child') && !str.includes('//')) {
    return 'C'
  } else if (str.includes('child') && str.includes('//')) {
    return `C${str.split('//')[1]}`
  } else if (str.includes('mother')) {
    return 'M'
  } else if (str.includes('father')) {
    return 'F'
  } else {
    return 'O'
  }
}

const columns2SV = React.forwardRef((props: Props, ref) => {
  const { t, i18n } = useTranslation()
  const ability = useContext(AbilityContext)

  const router = useRouter()

  const { id, ids, group } = router.query

  const type = router.asPath.includes('/samples') ? 'sample' : 'analyze'

  const column: TableColumnsType<Variation> = React.useMemo(() => {
    if (props.analysisInfo.pipelineVersion) {
      return [
        {
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Chrom')}
                </span>
              </Stack>
            </Stack>
          ),
          dataIndex: 'chrom',
          key: 'chrom',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: true,
          render: (value, row: any) => {
            return (
              <Stack
                maxWidth={'100px'}
                width={'100%'}
                marginTop={'12px'}
                direction="row"
                alignItems="center"
                justifyContent={'space-between'}
              >
                <TypographyA>{row.chrom}</TypographyA>
              </Stack>
            )
          },
          filters: chromosome
        },
        {
          title: () => (
            <Stack
              maxWidth={'100%'}
              justifyContent="start"
              alignItems="center"
              direction={'row'}
            >
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Start')}
                </span>

                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('End ')}
                </span>
              </Stack>
            </Stack>
          ),
          dataIndex: 'start',
          key: 'start',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: false,
          render: (value, row: any) => {
            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="start"
                sx={{
                  cursor: 'pointer'
                }}
                onClick={() => {
                  //
                  props.setIgvOpen(true)

                  props.setCurrent(row)

                  props.setIgvLocus(`chr${row.chrom}:${row.start}-${row.end}`)
                }}
              >
                {row.tempCnvManual && row.tempCnvManual.type ? (
                  <TypographyA>{t('Merge')}</TypographyA>
                ) : (
                  ''
                )}

                <TypographyA
                  sx={{
                    maxWidth: 80,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                  }}
                >
                  {row.start}
                </TypographyA>

                <TypographyA
                  sx={{
                    maxWidth: 80,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                  }}
                >
                  {row.end}
                </TypographyA>
              </Stack>
            )
          },
          ...props.getColumnSearchProps('start')
        },
        {
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Copy Number(CN)')}
                </span>
              </Stack>
            </Stack>
          ),
          dataIndex: 'cn',
          key: 'cn',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: true,
          render: (value, row: any) => {
            return (
              <Stack
                maxWidth={'100px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="center"
              >
                <TypographyA>{row.cn}</TypographyA>
              </Stack>
            )
          },
          ...props.getColumnSearchProps('CN')
        },
        {
          dataIndex: 'sv_type',
          key: 'sv_type',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: false,
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Type')}
                </span>
              </Stack>
            </Stack>
          ),
          render: (value, row: any) => {
            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="start"
              >
                <TypographyA>{row.sv_type}</TypographyA>
              </Stack>
            )
          },
          filters: [
            {
              value: 'DEL',
              text: i18n.language === 'zh' ? `DEL(${t('del')})` : 'DEL'
            },
            {
              value: 'DUP',
              text: i18n.language === 'zh' ? `DUP(${t('dup')})` : 'DUP'
            },
            {
              value: 'INS',
              text: i18n.language === 'zh' ? `INS(${t('ins')})` : 'INS'
            },
            {
              value: 'INV',
              text: i18n.language === 'zh' ? `INV(${t('inv')})` : 'INV'
            },
            {
              value: 'BND',
              text: i18n.language === 'zh' ? `BND(${t('bnd')})` : 'BND'
            }
          ]
        },
        {
          dataIndex: 'gene',
          key: 'gene',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: false,
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Gene')}
                </span>
              </Stack>
            </Stack>
          ),
          render: (value, row: any) => {
            const gene = row?.gene
            const scip_gene_info_data = row?.scip_gene_info ?? []

            return (
              <Stack
                sx={{
                  position: 'relative'
                }}
                maxWidth={'160px'}
                direction="row"
                alignItems="center"
                justifyContent={'space-between'}
              >
                <Stack
                  maxWidth={'130px'}
                  width={'100%'}
                  marginTop={'12px'}
                  direction="column"
                  alignItems="start"
                  sx={{
                    cursor: 'pointer'
                  }}
                  onClick={() => {
                    props.setCnvAllOpen && props.setCnvAllOpen(true)

                    props.setCurrent(row.original)
                  }}
                >
                  <Tooltip title={`${gene}`} placement="top-start">
                    <TypographyA
                      sx={{
                        width: '100%',
                        display: '-webkit-box',
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        wordBreak: 'break-all',
                        fontWeight: 500
                      }}
                    >
                      {gene ? (
                        <>
                          <span>{`${gene}`}</span>
                        </>
                      ) : null}
                    </TypographyA>
                  </Tooltip>
                </Stack>

                {scip_gene_info_data.length ? (
                  <IconButton
                    onClick={(e) => {
                      props.setCurrent(row.original)

                      props.handleMenuClick &&
                        props.handleMenuClick(e, 'scip_gene')
                    }}
                    sx={{
                      color: 'inherit',
                      padding: 0

                      // position: 'absolute',
                      // right: 0,
                      // bottom: '-1rem'
                    }}
                    size="small"
                  >
                    <MenuDown />
                  </IconButton>
                ) : (
                  ''
                )}
              </Stack>
            )
          },
          ...props.getColumnSearchProps('gene')
        },
        {
          dataIndex: 'coverage',
          key: 'coverage',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: true,
          title: () => (
            <Stack maxWidth={'100%'} direction={'row'} alignItems="center">
              <Tooltip
                placement="top-start"
                title={`实心圆表纯合，半实心表杂合；ref/alt`}
              >
                <Stack maxWidth={'100%'}>
                  <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                    {`${t('Zygosity')}/${t('Coverage')}`}
                  </span>
                </Stack>
              </Tooltip>
            </Stack>
          ),
          render: (value, row: any) => {
            return (
              <Stack
                maxWidth={'100%'}
                direction="column"
                spacing={1}
                marginTop={'12px'}
              >
                {(row.allele_frequency || row.allele_frequency === 0) &&
                row.allele_frequency !== '.' ? (
                  <Stack direction={'row'} alignItems="center" spacing={1}>
                    <Stack maxWidth={'100%'} direction="column" spacing={1}>
                      {row.allele_frequency < 0.85 ? (
                        <CircleHalfFull
                          sx={{ color: 'black', fontSize: '0.875rem' }}
                        />
                      ) : (
                        <Circle sx={{ color: 'black', fontSize: '0.875rem' }} />
                      )}
                    </Stack>

                    <TypographyA
                      sx={{
                        maxWidth: '100%'
                      }}
                    >
                      {`${row.coverage}  [${row.allele_frequency?.toFixed(
                        2
                      )}] `}
                    </TypographyA>
                  </Stack>
                ) : (
                  ''
                )}
              </Stack>
            )
          },
          ...props.getColumnSearchProps('coverage')

          // filters: [
          //   {
          //     value: 'homozygote',
          //     text: t('homozygote')
          //   },
          //   {
          //     value: 'heterozygote',
          //     text: t('heterozygote')
          //   },
          //   {
          //     value: 'compound hets',
          //     text: t('recombination')
          //   }
          // ]
        },
        {
          dataIndex: 'consensus',
          key: 'consensus',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: false,
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Consensus')}
                </span>
              </Stack>
            </Stack>
          ),
          render: (value, row: any) => {
            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="start"
                justifyContent={'center'}
              >
                <Tooltip placement="top-start" title={row.consensus}>
                  <TypographyA
                    sx={{
                      maxWidth: 80,
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis'
                    }}
                  >
                    {row.consensus}
                  </TypographyA>
                </Tooltip>
              </Stack>
            )
          }
        },
        {
          dataIndex: 'score_details',
          key: 'score_details',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: false,
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {`${t('ACMG evidences')}(Annotsv)`}
                </span>

                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {`ACMG ${t('score')}`}
                </span>

                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Length (bp)')}
                </span>
              </Stack>
            </Stack>
          ),
          render: (value, row: any) => {
            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="start"
                justifyContent={'center'}
              >
                <TypographyA>{row.score_details}</TypographyA>

                <TypographyA>{row.total_score}</TypographyA>

                <TypographyA
                  sx={{
                    maxWidth: 80,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                  }}
                >
                  {typeof row.sv_length === 'number'
                    ? Math.round(row.sv_length)
                    : row.sv_length}
                </TypographyA>
              </Stack>
            )
          }
        },
        {
          dataIndex: 'left_genes',
          key: 'left_genes',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: false,
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Left genes ')}
                </span>

                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {`Left location`}
                </span>
              </Stack>
            </Stack>
          ),
          render: (value, row: any) => {
            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="start"
                justifyContent={'center'}
              >
                <TypographyA>{row.left_genes}</TypographyA>

                <TypographyA>{row.left_location}</TypographyA>
              </Stack>
            )
          }
        },
        {
          dataIndex: 'right_genes',
          key: 'right_genes',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: false,
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Right genes ')}
                </span>

                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {`Right location`}
                </span>
              </Stack>
            </Stack>
          ),
          render: (value, row: any) => {
            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="start"
                justifyContent={'center'}
              >
                <TypographyA>{row.right_genes}</TypographyA>

                <TypographyA>{row.right_location}</TypographyA>
              </Stack>
            )
          }
        },
        {
          dataIndex: 'ccnv_priority',
          key: 'ccnv_priority',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: true,
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Tooltip title={'双软件注释(classifyCNV、annotsv)'}>
                <Stack maxWidth={'100%'}>
                  <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                    {t('ACMG')}
                  </span>
                </Stack>
              </Tooltip>
            </Stack>
          ),
          render: (value, row: any) => {
            const classification = row.classification

            const bgcolor = GLScolor.find(
              (i) => i.key === switchACMG(classification)?.toLowerCase()
            )
              ? (color.find(
                  (i) => i.key === switchACMG(classification)?.toLowerCase()
                )?.color as
                  | 'rgb(240,239,240,0.4)'
                  | 'rgba(221,109,32,0.8)'
                  | 'rgb(255,242,202)'
                  | 'rgb(245,182,193)')
              : 'rgba(0, 0, 0)'

            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="row"
                alignItems="center"
                justifyContent={'center'}
              >
                {classification && classification != '.' ? (
                  <Chip
                    sx={{
                      bgcolor: bgcolor,
                      color:
                        bgcolor === 'rgb(240,239,240,0.4)' ? 'black' : 'white',
                      justifyContent: 'start',
                      fontSize: '0.75rem'
                    }}
                    label={`${classification}`}
                    onClick={() => {
                      props.setCurrent(row)

                      props.setCnvScipOpen(true)
                    }}
                    size="small"
                  />
                ) : (
                  classification
                )}
              </Stack>
            )
          },
          filters: [
            {
              value: 'Pathogenic',
              text: 'Pathogenic'
            },
            {
              value: 'Likely pathogenic',
              text: 'Likely Pathogenic'
            },
            {
              value: 'Uncertain significance',
              text: 'Uncertain Significance'
            },
            {
              value: 'Likely benign',
              text: 'Likely Benign'
            },
            {
              value: 'Benign',
              text: 'Benign'
            }
          ]
        },
        {
          dataIndex: 'inheritance',
          key: 'inheritance',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: false,
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="center" direction={'row'}>
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('OMIM')}
                </span>
              </Stack>
            </Stack>
          ),
          render: (value, row: any) => {
            const omim_info = row.newOMIMInfo

            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="start"
              >
                <Tooltip
                  title={
                    <Box maxHeight={300} overflow="auto">
                      {omim_info?.map((item: any, index: any) => (
                        <TypographyA key={`${item.pheno_name_cn}_${index}`}>
                          {`(${item.inheritance ? item.inheritance : '.'})-${
                            item.pheno_name_cn
                          }`}
                        </TypographyA>
                      ))}
                    </Box>
                  }
                  placement={'top-start'}
                  TransitionComponent={Slide}
                  sx={{
                    '& .MuiTooltip-tooltip': {
                      maxWidth: isWindow() ? '400px' : '200px'
                    }
                  }}
                >
                  <Box width={'100%'}>
                    {omim_info?.slice(0, 5).map((items: any, index: any) => {
                      return (
                        <TypographyA
                          sx={{
                            width: '100%',
                            maxWidth: 300,
                            lineHeight: '24px',
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                            color: '#23527c',
                            mb: '4px'
                          }}
                          onClick={() => {
                            props.setCurrent(row.original)

                            props.setOMIMOpen(true)
                          }}
                          key={`${items.pheno_name_cn}_${index}`}
                        >
                          <Chip
                            label={`${
                              items.inheritance ? items.inheritance : '.'
                            }`}
                            size="small"
                            sx={{
                              height: 18,
                              fontSize: '0.75rem'
                            }}
                          />

                          <span
                            style={{
                              lineHeight: '24px'
                            }}
                          >
                            {`${items.pheno_name_cn}`}
                          </span>
                        </TypographyA>
                      )
                    })}
                  </Box>
                </Tooltip>
              </Stack>
            )
          },
          ...props.getColumnSearchProps('inheritance')
        },
        {
          dataIndex: 'callers',
          key: 'callers',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: true,
          title: () => (
            <Stack maxWidth={'100%'} direction={'row'} alignItems="center">
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Callers')}
                </span>
              </Stack>
            </Stack>
          ),
          render: (value, row: any) => {
            const callers = row.callers

            return (
              <Stack maxWidth={'100%'} direction="column" spacing={1}>
                <TypographyA>{callers}</TypographyA>
              </Stack>
            )
          }
        }
      ]
    } else
      return [
        {
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Chrom')}
                </span>
              </Stack>
            </Stack>
          ),
          dataIndex: 'grading',
          key: 'grading',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: true,
          render: (value, row: any) => {
            return (
              <Stack
                maxWidth={'60px'}
                width={'100%'}
                direction="column"
                alignItems="start"
              >
                <TypographyA>{row.chrom}</TypographyA>
              </Stack>
            )
          },
          filters: chromosome
        },
        {
          title: () => (
            <Stack
              maxWidth={'100%'}
              justifyContent="start"
              alignItems="center"
              direction={'row'}
            >
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Start')}
                </span>

                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('End ')}
                </span>
              </Stack>
            </Stack>
          ),
          dataIndex: 'SV_start',
          key: 'SV_start',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: false,
          render: (value, row: any) => {
            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="start"
                sx={{
                  cursor: 'pointer'
                }}
                onClick={() => {
                  //
                  props.setIgvOpen(true)

                  props.setCurrent(row)

                  props.setIgvLocus(
                    `chr${row.chrom}:${row.SV_start}-${row.SV_end}`
                  )
                }}
              >
                <TypographyA
                  sx={{
                    maxWidth: 80,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                  }}
                >
                  {row.SV_start}
                </TypographyA>

                <TypographyA
                  sx={{
                    maxWidth: 80,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                  }}
                >
                  {row.SV_end}
                </TypographyA>
              </Stack>
            )
          },
          ...props.getColumnSearchProps('start')
        },
        {
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Copy Number(CN)')}
                </span>
              </Stack>
            </Stack>
          ),
          dataIndex: 'CN',
          key: 'CN',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: true,
          render: (value, row: any) => {
            return (
              <Stack
                maxWidth={'100px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="center"
              >
                <TypographyA>{row.CN}</TypographyA>
              </Stack>
            )
          },
          ...props.getColumnSearchProps('CN')
        },
        {
          dataIndex: 'SVType',
          key: 'SVType',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: false,
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Type')}
                </span>
              </Stack>
            </Stack>
          ),
          render: (value, row: any) => {
            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="start"
              >
                <TypographyA>{row.SV_type}</TypographyA>
              </Stack>
            )
          },
          filters: [
            {
              value: 'DEL',
              text: i18n.language === 'zh' ? `DEL(${t('del')})` : 'DEL'
            },
            {
              value: 'DUP',
              text: i18n.language === 'zh' ? `DUP(${t('dup')})` : 'DUP'
            },
            {
              value: 'INS',
              text: i18n.language === 'zh' ? `INS(${t('ins')})` : 'INS'
            },
            {
              value: 'INV',
              text: i18n.language === 'zh' ? `INV(${t('inv')})` : 'INV'
            },
            {
              value: 'BND',
              text: i18n.language === 'zh' ? `BND(${t('bnd')})` : 'BND'
            }
          ]
        },
        {
          dataIndex: 'gene',
          key: 'gene',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: false,
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Gene')}
                </span>
              </Stack>
            </Stack>
          ),
          render: (value, row: any) => {
            const omim_genes = row?.ExomeDepth_omim_genes?.join(';')
            const omim_disease_genes = row.gene_info?.omim_disease_genes
              .map((item: any) => item.symbol)
              .join(';')
            const other_genes = row.gene_info?.other_genes?.join(';')

            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="start"
                sx={{
                  cursor: 'pointer'
                }}
                onClick={() => {
                  props.setCnvAllOpen(true)

                  props.setCurrent(row)
                }}
              >
                <Tooltip title={`${omim_disease_genes}`} placement="top-start">
                  <TypographyA
                    sx={{
                      width: '100%',
                      display: '-webkit-box',
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      wordBreak: 'break-all',
                      fontWeight: 500
                    }}
                  >
                    {omim_disease_genes ? (
                      <>
                        <span
                          style={{
                            color: 'red'
                          }}
                        >{`${omim_disease_genes}`}</span>
                      </>
                    ) : null}
                  </TypographyA>
                </Tooltip>

                {/* <Tooltip title={omim_genes} placement="right-start">
                <TypographyA
                  sx={{
                    width: '100%',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                  }}
                >
                  {omim_genes ? `omim_genes:${omim_genes}` : null}
                </TypographyA>
              </Tooltip> */}

                <Tooltip title={other_genes} placement="top-start">
                  {/* <TypographyA
                  sx={{
                    width: '100%',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                  }}
                >
                  {other_genes ? `OTHER OMIM GENES:${other_genes}` : null}
                </TypographyA> */}
                  <TypographyA
                    sx={{
                      width: '100%',
                      display: '-webkit-box',
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      wordBreak: 'break-all',
                      fontWeight: 500
                    }}
                  >
                    {other_genes ? (
                      <>
                        <span>{`${other_genes}`}</span>
                      </>
                    ) : null}
                  </TypographyA>
                </Tooltip>
              </Stack>
            )
          },
          ...props.getColumnSearchProps('gene')
        },
        {
          dataIndex: 'coverage',
          key: 'coverage',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: true,
          title: () => (
            <Stack maxWidth={'100%'} direction={'row'} alignItems="center">
              <Tooltip
                placement="top-start"
                title={`实心圆表纯合，半实心表杂合；ref/alt`}
              >
                <Stack maxWidth={'100%'}>
                  <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                    {`${t('Zygosity')}/${t('Coverage')}`}
                  </span>
                </Stack>
              </Tooltip>
            </Stack>
          ),
          render: (value, row: any) => {
            let bgcolor = color.find(
              (i) => i.key === row.CLINSIG_final?.toLowerCase()
            )
              ? (color.find((i) => i.key === row.CLINSIG_final?.toLowerCase())
                  ?.color as any)
              : 'rgba(0, 0, 0)'

            // loss_of_function等于1 并且CLINSIG_final不等于P/LP
            if (row.CLINSIG_final?.toLowerCase() === 'pathogenic') {
              //
            } else if (
              row.CLINSIG_final?.toLowerCase() === 'likely pathogenic'
            ) {
              //
            } else if (row.loss_of_function === 1) bgcolor = '#f5d18c'

            return (
              <Stack maxWidth={'100%'} direction="column" spacing={1}>
                {(row.allele_frequency || row.allele_frequency === 0) &&
                row.allele_frequency !== '.' ? (
                  <Stack direction={'row'} alignItems="center" spacing={1}>
                    <Stack maxWidth={'100%'} direction="column" spacing={1}>
                      {row.allele_frequency < 0.85 ? (
                        <CircleHalfFull
                          sx={{ color: 'black', fontSize: '0.875rem' }}
                        />
                      ) : (
                        <Circle sx={{ color: 'black', fontSize: '0.875rem' }} />
                      )}
                    </Stack>

                    <TypographyA
                      sx={{
                        maxWidth: '100%'
                      }}
                    >
                      {`${row.coverage}  [${row.allele_frequency?.toFixed(
                        2
                      )}] `}
                    </TypographyA>
                  </Stack>
                ) : (
                  ''
                )}
              </Stack>
            )
          },
          ...props.getColumnSearchProps('coverage')

          // filters: [
          //   {
          //     value: 'homozygote',
          //     text: t('homozygote')
          //   },
          //   {
          //     value: 'heterozygote',
          //     text: t('heterozygote')
          //   },
          //   {
          //     value: 'compound hets',
          //     text: t('recombination')
          //   }
          // ]
        },
        {
          dataIndex: 'consensus',
          key: 'consensus',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: false,
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Consensus')}
                </span>
              </Stack>
            </Stack>
          ),
          render: (value, row: any) => {
            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="start"
                justifyContent={'center'}
              >
                <Tooltip placement="top-start" title={row.consensus}>
                  <TypographyA
                    sx={{
                      maxWidth: 80,
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis'
                    }}
                  >
                    {row.consensus}
                  </TypographyA>
                </Tooltip>
              </Stack>
            )
          }
        },
        {
          dataIndex: 'ClassifyCNV_evidences',
          key: 'ClassifyCNV_evidences',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: false,
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {`${t('ACMG evidences')}(Annotsv)`}
                </span>

                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {`ACMG ${t('score')}`}
                </span>

                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Length (bp)')}
                </span>
              </Stack>
            </Stack>
          ),
          render: (value, row: any) => {
            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="start"
                justifyContent={'center'}
              >
                <TypographyA>{row.AnnotSV_evidences}</TypographyA>

                <TypographyA>{row.total_score}</TypographyA>

                <TypographyA
                  sx={{
                    maxWidth: 80,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                  }}
                >
                  {row.LEN}
                </TypographyA>
              </Stack>
            )
          }
        },
        {
          dataIndex: 'left_genes',
          key: 'left_genes',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: false,
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Left genes ')}
                </span>

                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {`Left location`}
                </span>
              </Stack>
            </Stack>
          ),
          render: (value, row: any) => {
            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="start"
                justifyContent={'center'}
              >
                <TypographyA>{row.left_genes}</TypographyA>

                <TypographyA>{row.left_location}</TypographyA>
              </Stack>
            )
          }
        },
        {
          dataIndex: 'right_genes',
          key: 'right_genes',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: false,
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Right genes ')}
                </span>

                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {`Right location`}
                </span>
              </Stack>
            </Stack>
          ),
          render: (value, row: any) => {
            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="start"
                justifyContent={'center'}
              >
                <TypographyA>{row.right_genes}</TypographyA>

                <TypographyA>{row.right_location}</TypographyA>
              </Stack>
            )
          }
        },
        {
          dataIndex: 'ccnv_priority',
          key: 'ccnv_priority',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: true,
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('ACMG')}
                </span>
              </Stack>
            </Stack>
          ),
          render: (value, row: any) => {
            const classification = row.classification
            const flag =
              (classification?.toLowerCase() === 'likely pathogenic' ||
                classification?.toLowerCase() === 'pathogenic') &&
              classification !== row.ccnv_classification

            //

            const bgcolor = GLScolor.find(
              (i) => i.key === row.ccnv_classification?.toLowerCase()
            )
              ? (color.find(
                  (i) => i.key === row.ccnv_classification?.toLowerCase()
                )?.color as
                  | 'rgb(240,239,240,0.4)'
                  | 'rgba(221,109,32,0.8)'
                  | 'rgb(255,242,202)'
                  | 'rgb(245,182,193)')
              : 'rgba(0, 0, 0)'

            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="row"
                alignItems="center"
              >
                {row.ccnv_classification && row.ccnv_classification != '.' ? (
                  <Chip
                    sx={{
                      bgcolor: bgcolor,
                      color:
                        bgcolor === 'rgb(240,239,240,0.4)' ? 'black' : 'white',
                      justifyContent: 'start',
                      fontSize: '0.75rem'
                    }}
                    label={`${
                      row.ccnv_classification && row.ccnv_classification != '.'
                        ? row.ccnv_classification
                            .split(' ')
                            .map((word: any) => {
                              if (word.includes('Uncertain')) return `VU`
                              if (word.includes('null')) return ``
                              else return word[0].toUpperCase()
                            })
                            .join('')
                        : '.'
                    }`}
                    onClick={() => {
                      // setAcmgOpen(true)
                      // props.setCurrent(row)
                    }}
                    size="small"
                  />
                ) : (
                  row.ccnv_classification
                )}

                {flag ? (
                  <Tooltip
                    placement="top-start"
                    title={`AnnotSV:${classification}`}
                  >
                    <Box
                      sx={{
                        width: '10px',
                        height: '10px',
                        bgcolor: 'red',
                        borderRadius: '50%',
                        display: 'inline-block'
                      }}
                    ></Box>
                  </Tooltip>
                ) : (
                  ''
                )}
              </Stack>
            )
          },
          filters: [
            {
              value: 'Pathogenic',
              text: 'Pathogenic'
            },
            {
              value: 'Likely pathogenic',
              text: 'Likely Pathogenic'
            },
            {
              value: 'Uncertain significance',
              text: 'Uncertain Significance'
            },
            {
              value: 'Likely benign',
              text: 'Likely Benign'
            },
            {
              value: 'Benign',
              text: 'Benign'
            }
          ]
        },
        {
          dataIndex: 'inheritance',
          key: 'inheritance',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: false,
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="center" direction={'row'}>
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('OMIM')}
                </span>
              </Stack>
            </Stack>
          ),
          render: (value, row: any) => {
            const omim_info = row.omim_info

            const bgcolor = color.find(
              (i) => i.key === row.ccnv_classification?.toLowerCase()
            )
              ? (color.find(
                  (i) => i.key === row.ccnv_classification?.toLowerCase()
                )?.color as any)
              : 'rgba(0, 0, 0)'

            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="start"
              >
                <Tooltip
                  title={
                    <Box maxHeight={300} overflow="auto">
                      {omim_info?.map((item: any, index: any) => (
                        <TypographyA key={`${item.pheno_name_cn}_${index}`}>
                          {`(${item.inheritance ? item.inheritance : '.'})-${
                            item.pheno_name_cn
                          }`}
                        </TypographyA>
                      ))}
                    </Box>
                  }
                  placement={'top-start'}
                  TransitionComponent={Slide}
                  sx={{
                    '& .MuiTooltip-tooltip': {
                      maxWidth: isWindow() ? '400px' : '200px'
                    }
                  }}
                >
                  <Box width={'100%'}>
                    {omim_info?.slice(0, 5).map((items: any, index: any) => {
                      return (
                        <TypographyA
                          sx={{
                            width: '100%',
                            maxWidth: 300,
                            lineHeight: '24px',
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                            color:
                              bgcolor === 'rgb(109,56,149,0.8)' ||
                              bgcolor === 'rgb(107,148,200,0.8)' ||
                              bgcolor === 'rgba(229,38,35,0.8)'
                                ? 'white'
                                : '#23527c',
                            mb: '4px'
                          }}
                          onClick={() => {
                            props.setCurrent(row)

                            props.setOMIMOpen(true)
                          }}
                          key={`${items.pheno_name_cn}_${index}`}
                        >
                          <Chip
                            label={`${
                              items.inheritance ? items.inheritance : '.'
                            }`}
                            size="small"
                            sx={{
                              height: 18,
                              fontSize: '0.75rem'
                            }}
                          />

                          <span
                            style={{
                              lineHeight: '24px'
                            }}
                          >{`${items.pheno_name_cn}`}</span>
                        </TypographyA>
                      )
                    })}
                  </Box>
                </Tooltip>
              </Stack>
            )
          },
          ...props.getColumnSearchProps('inheritance')
        },
        {
          dataIndex: 'P_snvindel_nb',
          key: 'P_snvindel_nb',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: true,
          title: () => (
            <Stack maxWidth={'100%'} direction={'row'} alignItems="center">
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  Pathogenic
                </span>

                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  SNV/INDEL
                </span>

                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  overlapped
                </span>
              </Stack>
            </Stack>
          ),
          render: (value, row: any) => {
            return (
              <Stack
                maxWidth={'150px'}
                width={'100%'}
                marginTop={'12px'}
                direction="column"
                alignItems="start"
              >
                <Tooltip title={`${row.P_snvindel_nb}`} placement="top-start">
                  <TypographyA
                    sx={{
                      maxWidth: '100%',
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis'
                    }}
                  >
                    {`${row.P_snvindel_nb}`}
                  </TypographyA>
                </Tooltip>
              </Stack>
            )
          }
        },

        {
          dataIndex: 'DDD_HI_percent',
          key: 'DDD_HI_percent',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: false,
          title: () => (
            <Stack maxWidth={'100%'} direction={'row'} alignItems="center">
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('DDD HI')}
                </span>

                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('LOEUF bin')}
                </span>

                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('GnomAD pLI')}
                </span>
              </Stack>
            </Stack>
          ),
          render: (value, row: any) => {
            return (
              <Stack maxWidth={'100%'} direction="column" spacing={1}>
                <TypographyA
                  sx={{
                    width: '100%',
                    maxWidth: 140,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                  }}
                >
                  {`${row.DDD_HI_percent}`}
                </TypographyA>

                <TypographyA
                  sx={{
                    width: '100%',
                    maxWidth: 140,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                  }}
                >
                  {`${row.LOEUF_bin}`}
                </TypographyA>

                <TypographyA
                  sx={{
                    width: '100%',
                    maxWidth: 140,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                  }}
                >
                  {`${
                    row.GnomAD_pLI === '.' || row.GnomAD_pLI === 'NaN'
                      ? '.'
                      : (Number(row.GnomAD_pLI).toFixed(
                          4
                        ) as unknown as number) == 0
                      ? 0
                      : Number(row.GnomAD_pLI).toFixed(4)
                  }`}
                </TypographyA>
              </Stack>
            )
          }
        },
        {
          dataIndex: 'clinvar_info',
          key: 'clinvar_info',
          align: 'center',
          width: 80,
          ellipsis: true,
          sorter: true,
          title: () => (
            <Stack maxWidth={'100%'} direction={'row'} alignItems="center">
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('clinvar Info')}
                </span>
              </Stack>
            </Stack>
          ),
          render: (value, row: any) => {
            const clinvar_info: any[] = row.clinvar_info ?? []

            return (
              <Stack maxWidth={'100%'} direction="column" spacing={1}>
                <TypographyA
                  onClick={(e) => {
                    if (clinvar_info.length) {
                      props.setCurrent(row)

                      props.handleMenuClick(e, 'clinvar_info')
                    }
                  }}
                  sx={{
                    cursor: 'pointer'
                  }}
                >
                  {clinvar_info.length}
                </TypographyA>
              </Stack>
            )
          }
        }
      ]
  }, [props])

  React.useImperativeHandle(ref, () => ({
    column
  }))

  return <></>
})

export default columns2SV
